<template lang="pug">
    div.maintenance-form
        template(v-if="ignoreStatus && !isCompleteOrder")
            div.jump-tag 跳过
            div.info-operator 提交人：
                span {{ detailData.maintenance.operatorName }} {{ detailData.maintenance.operatorPhone }} {{ detailData.maintenance.operateTime | dateFormat }}
        template(v-if="stashStatus || commitStatus || isCompleteOrder")
            el-form(
                :model="formData"
                :rules="rules"
                ref="form"
                :class="{'small-margin': commitStatus}"
            )
                el-form-item.upload-pictures.margin-bottom-12(
                    :class="{'required-star': !commitStatus}"
                    label="完工凭证："
                    prop="maintenancePicture"
                )
                    UploadFormItem(v-if="stashStatus || isCompleteOrder" @change="onPicChange" :asyncfileList="maintenancePictureFull", :limit="12")
                    div.images(v-if="commitStatus && maintenancePictureFull && maintenancePictureFull.length")
                        img(
                            v-for="(img, idx) in maintenancePictureFull"
                            :key="idx"
                            style="width: 78px; height: 78px; margin-right: 10px; margin-bottom: 10px"
                            :src="img.url"
                            @click="handleShowImage(img, maintenancePictureFull)"
                        )
                el-form-item.upload-pictures(
                    :class="{'padding-left': !commitStatus}"
                    label="备注："
                    prop="maintenanceRemark"
                )
                    el-input(
                        v-if="stashStatus || isCompleteOrder"
                        v-model.trim="formData.maintenanceRemark"
                        :rows="4"
                        style="width: 430px;"
                        resize="none"
                        type="textarea"
                        maxlength="100"
                        placeholder="请输入"
                        :show-word-limit="true"
                    )
                    div.remark-view(v-if="commitStatus") {{ formData.damageRemark | fieldVaild }}
            div.info-operator(v-if="commitStatus") 提交人：
                span {{ detailData.maintenance.operatorName }} {{ detailData.maintenance.operatorPhone }} {{ detailData.maintenance.operateTime | dateFormat }}
            span.dialog-footer(v-if="stashStatus || isCompleteOrder" slot="footer" style="margin-top: 20px")
                el-popover(placement="bottom" width="172" v-model="visible" popper-class="padding-16 text-left")
                    div(style="text-align: right; margin: 0")
                        p 确认跳过当前处理？
                        el-button.pop-button(@click="visible = false") 取消
                        el-button.pop-button.primary(@click="handleIgnore") 确定
                    el-button.button(slot="reference" round :loading="loading" v-if="!isCompleteOrder") 跳过
                el-button.button(round :loading="loading" @click="handleStash" v-if="!isCompleteOrder") 保存
                el-popover(placement="bottom" width="190" v-model="visible2" popper-class="padding-16 text-left")
                    div(style="text-align: right; margin: 0")
                        p 确认提交当前处理结果？
                        el-button.pop-button(@click="visible2 = false") 取消
                        el-button.pop-button.primary(@click="handleSubmit") 确定
                    el-button.button(slot="reference" round type="primary" :loading="loading") 提交
</template>

<script>
import UploadFormItem from '@/components/Common/UploadFormItem.vue';
import workOrderMixin from '../../../mixins/workOrder';

export default {
    name: 'Maintenance',
    components: {
        UploadFormItem,
    },
    props: {
        detailData: {
            type: Object,
            default: () => {},
        },
        loading: {
            type: Boolean,
            default: false,
        },
        formType: {
            type: String,
            default: 'resolve',
        },
    },
    mixins: [workOrderMixin],
    data() {
        const validateImage = (rule, value, callback) => {
            if (!this.isStash && (!this.maintenancePic || !this.maintenancePic.length)) {
                callback(new Error('请上传完工凭证图片'));
            } else {
                callback();
            }
        };
        return {
            formData: {
                stepName: 'MAINTENANCE',
                maintenancePicture: [],
                maintenanceRemark: '',
            },
            rules: {
                maintenancePicture: [
                    {
                        trigger: 'change',
                        validator: validateImage,
                    },
                ],
            },
            maintenancePictureFull: [],
            maintenancePic: [],
            isStash: false,
            visible: false,
            visible2: false,
        };
    },
    computed: {
        stashStatus() {
            return !this.detailData.maintenance || this.detailData.maintenance.itemStatus === 'STASH';
        },
        ignoreStatus() {
            return this.detailData.maintenance && this.detailData.maintenance.itemStatus === 'IGNORE';
        },
        commitStatus() {
            return this.detailData.maintenance && this.detailData.maintenance.itemStatus === 'COMMIT';
        },
        isCompleteOrder() {
            return this.formType === 'complete';
        },
    },
    methods: {
        initFormData() {
            if (!this.detailData.maintenance || this.detailData.maintenance.itemStatus === 'IGNORE') return;
            const data = this.detailData.maintenance.content || {};
            this.formData = Object.assign({}, this.formData, data);
            this.fillBackPic(data, 'maintenancePicture', 'maintenancePic');
        },
        onPicChange(files) {
            this.maintenancePic = files;
            this.$refs.form.clearValidate('maintenancePicture');
        },
        async validateFormData(type) {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let urls = [];
                    if (this.maintenancePic.length) {
                        urls = await this.uploadToOss(this.maintenancePic).catch(() => {
                            this.$message('完工凭证图片上传失败');
                            throw new Error('完工凭证图片上传失败');
                        });
                        this.formData.maintenancePicture = urls;
                    }
                    this.$emit('submit', { data: this.formData, type });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.maintenance-form {
    padding: 20px 0 20px 20px;
    flex: 1;
    .jump-tag {
        width: 60px;
        height: 30px;
        line-height: 28px;
        text-align: center;
        background: #F5F5F5;
        border: 1px solid #EEEEEE;
        border-radius: 4px;
        font-size: 14px;
        color: #999999;
        margin-bottom: 10px;
        font-weight: normal;
    }
    .info-operator {
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
    }
    .images {
        margin: 8px 0 0 0;
        display: flex;
        flex-wrap: wrap;
    }
    .remark-view {
        line-height: 22px;
        width: 400px;
        // padding-top: 5px;
    }
    .dialog-footer {
        margin-top: 20px;
    }
}
.pop-button {
    width: 44px;
    height: 24px;
    border-radius: 4px;
    padding: 0!important;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
    border: 1px solid rgba(0,0,0,0.15);
    &.primary {
        color: #FFFFFF;
        background: #2970FF;
        border: none;
        margin-left: 8px;
    }
}
</style>

<style lang="scss">
.maintenance-form {
    overflow-y: hidden;
    .el-form {
        max-height: 500px;
        overflow-y: auto;
    }
    .el-form .el-form-item__content {
        padding-left: 114px;
    }
    .el-form-item__label {
        width: 114px;
        padding: 0;
    }
    .el-icon-date:before {
        position: relative;
        top: -4px;
    }
    .padding-left {
        .el-form-item__label {
            padding-left: 10px;
        }
    }
    .upload-pictures {
        .upload {
            height: auto;
            padding-left: 0!important;
            min-height: 80px;
        }
    }
    .el-form-item__error {
        margin-left: 114px;
    }
    .required-star {
        .el-form-item__label::before {
            content: '*';
            color: #F56C6C;
            margin-right: 4px;
        }
    }
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
        display: none;
    }
    .el-textarea .el-input__count {
        border-bottom: 0;
        background-color: transparent!important;
    }
    ul.el-upload-list--picture-card {
        line-height: 0;
    }
    .upload-form-item .upload .el-upload--picture-card {
        margin-bottom: 8px;
    }
    .margin-bottom-12 {
        margin-bottom: 12px!important;
        .el-form-item__error {
            top: calc(100% - 8px);
        }
    }
    .small-margin {
        .el-form-item {
            margin-bottom: 12px!important;
            .el-form-item__label, .el-form-item__content {
                line-height: 22px;
            }
        }
    }
}
</style>
